import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /endpoints.
 */
export default class EndpointsClient extends CRUD {
	constructor() {
		super('/endpoints');
	}

	create({ mock = false, type, specId }) {
		const qs = new URLSearchParams();
		mock && qs.append('mock', mock);
		type && qs.append('type', type);
		specId && qs.append('specId', specId);
		return this._op('post', `${this.uri}?${qs}`);
	}

	getApiSpecTypes() {
		return this._op('get', `${this.uri}/types`);
	}

	getGroupSummaries() {
		return this._op('get', `${this.uri}/summary`);
	}

	getEndpoints(endpointName) {
		const name = encodeURIComponent(endpointName);
		return this._op('get', `${this.uri}/${name}`, null);
	}

	getSwagger(endpointName) {
		const name = encodeURIComponent(endpointName);
		return this.invoke('get', `${window.$conf.apiDocPrefix}/swagger.json?endpoints/${name}&force=true&ignoreOverrides=true`);
	}

	generateEndpoints(params) {
		return this._op('post', `${this.uri}/generate`, params);
	}

	deleteEndpoint(params) {
		return this._op('delete', `${this.uri}/${encodeURIComponent(params.endpointId)}/endpoint`, params.data);
	}

	deleteSpec(type) {
		const specType = encodeURIComponent(type);
		return this._op('delete', `${this.uri}/${specType}`);
	}

	bindFlow(endpointId, data) {
		return this._op('post', `${this.uri}/${encodeURIComponent(endpointId)}/flow`, data);
	}

	validateSwagger(params) {
		const { fileOrUrl, type } = params;
		const form = new FormData();
		if (typeof fileOrUrl === 'string') {
			form.append('url', fileOrUrl);
		} else {
			form.append('file', fileOrUrl);
		}
		return this._op('put', `${this.uri}/validate?type=${type}`, form);
	}
}
